module.exports = __webpack_public_path__ + "static/media/operational-management-kn.ca8ec8ff.svg";